import axios from '../../../axiosConfig';

export async function getDepreciationGroups(config = {}, clientId) {
    return await axios.get(`/v1/depreciation-group/all/${clientId}`, config);
}

export async function getDepreciationGroupsSimple(clientId, config = {}) {
    return await axios.get(`/v1/depreciation-group/${clientId}/simple`, config);
}

export async function getDepreciationGroupById(id, config = {}) {
    return await axios.get(`/v1/depreciation-group/${id}`, config);
}

export async function createDepreciationGroup(data, config = {}) {
    return await axios.post(`/v1/depreciation-group`, data, config);
}

export async function updateDepreciationGroup(data, config = {}) {
    return await axios.put(`/v1/depreciation-group/${data.id}`, data, config);
}

export async function deleteDepreciationGroup(depreciationGroupId, config = {}) {
    return await axios.delete(`/v1/depreciation-group/${depreciationGroupId}`, config);
}


const functions = { getDepreciationGroups, getDepreciationGroupsSimple, getDepreciationGroupById, createDepreciationGroup, updateDepreciationGroup, deleteDepreciationGroup }
export default functions
